import { IMoveToProjectParams } from '../types/IMoveToProjectParams';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export class MoveFlowDraftsToProjectRequest extends Request<IMoveToProjectParams, IResult> {
  constructor(params: IMoveToProjectParams) {
    super('moveFlowDraftsToProject', params);
  }
}
